import { QUICK_TEST_STATUS } from './QuickTestConstants';

export function shouldPoll(status) {
    if (
        status === QUICK_TEST_STATUS.COMPLETE ||
        status === QUICK_TEST_STATUS.CANCELED ||
        status === QUICK_TEST_STATUS.ERROR
    ) {
        return false;
    }

    return true;
}
